import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostKey } from '../../utils/keys';
import { useAuthMember } from '../auth';
import { getCachedRootPostByReplies, infinitePostUpdater, addReactionToPost, infinitePostArrayUpdater, getCachedPost, } from '../cache/useCachedPost';
import { pinnedPostsFilter, postsQueryFilter } from './filters';
export const useAddReaction = (options) => {
    const queryClient = useQueryClient();
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const { data: authMember } = useAuthMember();
    const userReaction = {
        participant: {
            ...authMember,
        },
    };
    return useMutation((input) => client.posts.addReaction(input), {
        onMutate: async (addReactionArgs) => {
            const { reaction } = addReactionArgs.input;
            // updating the post itself
            const postKey = getPostKey({
                variables: { id: addReactionArgs === null || addReactionArgs === void 0 ? void 0 : addReactionArgs.postId },
            });
            await queryClient.cancelQueries(postKey);
            const postSnapshot = getCachedPost(addReactionArgs === null || addReactionArgs === void 0 ? void 0 : addReactionArgs.postId, queryClient);
            if (postSnapshot) {
                queryClient.setQueriesData(postKey, addReactionToPost(reaction, userReaction));
            }
            // updating pinned posts
            const pinnedPostsSnapshot = queryClient.getQueriesData(pinnedPostsFilter);
            if (pinnedPostsSnapshot) {
                queryClient.setQueriesData(pinnedPostsFilter, oldPosts => oldPosts.map(infinitePostArrayUpdater(addReactionArgs.postId, addReactionToPost(reaction, userReaction), true)));
            }
            // take a snapshot from all matched posts queries
            const postsSnapshots = queryClient.getQueriesData(postsQueryFilter);
            // update posts and replies within the found post everywhere (posts and the feed queries)
            queryClient.setQueriesData(postsQueryFilter, infinitePostUpdater(addReactionArgs.postId, addReactionToPost(reaction, userReaction), true));
            // updating root post if adding the reaction on a reply if no feed/posts have found
            let rootPostSnapshot;
            let rootPostKey;
            if (!(pinnedPostsSnapshot === null || pinnedPostsSnapshot === void 0 ? void 0 : pinnedPostsSnapshot.length) && !(postsSnapshots === null || postsSnapshots === void 0 ? void 0 : postsSnapshots.length)) {
                const rootPost = getCachedRootPostByReplies(addReactionArgs.postId, queryClient);
                if (rootPost &&
                    rootPost.replies &&
                    rootPost.id !== addReactionArgs.postId) {
                    rootPostKey = getPostKey({ variables: { id: rootPost === null || rootPost === void 0 ? void 0 : rootPost.id } });
                    rootPostSnapshot = queryClient.getQueryData(rootPostKey);
                    if (rootPostSnapshot) {
                        queryClient.setQueriesData(rootPostKey, infinitePostArrayUpdater(addReactionArgs.postId, addReactionToPost(reaction, userReaction), true));
                    }
                }
            }
            return [
                [postKey, postSnapshot],
                [rootPostKey, rootPostSnapshot],
                ...pinnedPostsSnapshot,
                ...postsSnapshots,
            ];
        },
        onError: (error, variables, context) => {
            context.forEach(([queryKey, snapshot]) => {
                if (queryKey) {
                    queryClient.setQueriesData(queryKey, snapshot);
                }
            });
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddReaction.js.map